import { trendInsights } from '@/mocks/homeData';
import type { TrendInsight } from '@/pages/home/types';

const insights = trendInsights as TrendInsight[];

export default function InsightsSection() {
  return (
    <section id="insights" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-6xl">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-sm text-primary-600">
              <i className="ri-line-chart-line"></i>
              数据洞察
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">各内容分区的热度分布</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              热度指数综合了播放、互动与完播表现，数值越高代表该分区在当前周期内的整体活跃度越强。可据此安排自己的观看节奏。
            </p>
          </div>
          <div className="flex gap-6 text-sm text-foreground-500">
            <div>
              <div className="font-heading text-2xl text-primary-600">6</div>
              <div className="text-xs">重点分区</div>
            </div>
            <div>
              <div className="font-heading text-2xl text-accent-700">30min</div>
              <div className="text-xs">数据刷新间隔</div>
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-x-10 lg:gap-y-5">
          {insights.map((item) => (
            <div key={item.label} className="rounded-lg border border-background-200/80 bg-background-100/50 p-4 md:p-5">
              <div className="flex items-center justify-between text-sm">
                <span className="inline-flex items-center gap-2 text-foreground-900">
                  <i className="ri-bar-chart-2-line text-accent-600"></i>
                  {item.label}
                </span>
                <span className="font-heading text-lg text-foreground-900">{item.share}</span>
              </div>
              <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-background-200">
                <div className="h-full rounded-full bg-accent-500" style={{ width: `${item.share}%` }}></div>
              </div>
              <p className="mt-3 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}